@if (mode === 'edit') {
<div class="ppl-mt20">
  <!-- nz-form on a div, not a <form>: the wizard already renders this inside its own form,
       and nesting forms is invalid HTML. The directive is what adds ant-form-horizontal,
       which the global label styles (left-aligned, 600 weight) key off. -->
  <div nz-form nz-row class="ppl-p0" [formGroup]="form">
    <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="labelSpan" [nzXs]="24" nzFor="servesAll" class="ppl-form-label">
          Who do you provide this service to?
          <span>*</span>
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-radio-group formControlName="servesAll" class="ppl-radio-group" id="servesAll">
            <label nz-radio-button nzValue="Yes">People with and without I/DD</label>
            <label nz-radio-button nzValue="No">Only individuals with I/DD</label>
          </nz-radio-group>
          @if (showError('servesAll')) {
          <span class="pl-1 error-message">An answer is required</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>

    @if (showVendored) {
    <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="labelSpan" [nzXs]="24" nzFor="vendored" class="ppl-form-label">
          Are you vendored for this service with a regional center?
          <span>*</span>
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-radio-group formControlName="vendored" class="ppl-radio-group" id="vendored">
            <label nz-radio-button nzValue="Yes">Yes</label>
            <label nz-radio-button nzValue="No">No</label>
          </nz-radio-group>
          @if (showError('vendored')) {
          <span class="pl-1 error-message">An answer is required</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if (showProgramDesignQuestion) {
    <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="labelSpan" [nzXs]="24" nzFor="followsProgramDesign" class="ppl-form-label">
          Are you providing services and billing in accordance with your Regional Center program design (including
          billing at your traditional Regional Center rate(s))?
          <span>*</span>
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-radio-group formControlName="followsProgramDesign" class="ppl-radio-group" id="followsProgramDesign">
            <label nz-radio-button nzValue="Yes">Yes</label>
            <label nz-radio-button nzValue="No">No</label>
          </nz-radio-group>
          @if (showError('followsProgramDesign')) {
          <span class="pl-1 error-message">An answer is required</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if (showVendorDetails) {
    <nz-form-item nz-col nzSpan="12" [nzXs]="24" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="labelSpan" [nzXs]="24" nzFor="vendorNumber" class="ppl-form-label">
          Regional Center Vendor Number
          <span>*</span>
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <input nz-input formControlName="vendorNumber" id="vendorNumber"
            placeholder="Regional Center Vendor Number" />
          @if (showError('vendorNumber')) {
          <span class="pl-1 error-message">Regional Center Vendor Number is required</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left derived-provider-type">
      <nz-row>
        <nz-form-label [nzSm]="labelSpan" [nzXs]="24" class="ppl-form-label">Provider Type</nz-form-label>
        <nz-form-control class="ppl-form-control">
          @if (derivedProviderType) {
          <strong>{{ derivedProviderType }}</strong>
          } @else {
          <span class="ppl-gray-text">Answer the questions above to determine the Provider Type.</span>
          }
          <p class="ppl-gray-text derived-note">Derived from the answers above and not separately editable.</p>
        </nz-form-control>
      </nz-row>
    </nz-form-item>

    <!-- Signature attestation. Not one of the saved answers - it gates saving only, and is
         confirmed again each time the classification is edited, so it sits outside [formGroup]. -->
    <nz-form-item nz-col nzSpan="24" [nzXs]="24" class="ppl-form-item nz-padding-left classification-attestation">
      <nz-form-control class="ppl-form-control">
        <label nz-checkbox [formControl]="attestation" id="classificationAttestation"
          [nzDisabled]="!!form?.disabled">
          I confirm that the classification answers above are accurate and complete to the best of my knowledge.
          Checking this box serves as my signature.
          <span class="required-marker">*</span>
        </label>
        @if (showAttestationError) {
        <div class="error-message attestation-error">Confirmation is required before the classification can be saved</div>
        }
      </nz-form-control>
    </nz-form-item>
  </div>
</div>
} @else {
<div nz-row>
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Who do you provide this service to?
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ servesAll === 'Yes' ? 'People with and without I/DD' : servesAll === 'No' ? 'Only individuals with I/DD' :
        '-' }}
      </div>
    </div>
  </div>
  @if (showVendored) {
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Are you vendored for this service with a regional center?
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ vendored ? vendored : '-' }}
      </div>
    </div>
  </div>
  }
  @if (showProgramDesignQuestion) {
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Are you providing services and billing in accordance with your Regional Center program design (including billing
        at your traditional Regional Center rate(s))?
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ followsProgramDesign ? followsProgramDesign : '-' }}
      </div>
    </div>
  </div>
  }
  @if (showVendorDetails) {
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Regional Center Vendor Number
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ control('vendorNumber')?.value ? control('vendorNumber')?.value : '-' }}
      </div>
    </div>
  </div>
  }
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        Provider Type
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ derivedProviderType ? derivedProviderType : '-' }}
      </div>
    </div>
  </div>
</div>
}
